import {PageLoader} from '@shared/PageLoader/PageLoader';
import dynamic from 'next/dynamic';

export const ArticleInfoBlock = dynamic(
  async () => import('./ArticleInfoBlock/ArticleInfoBlock'),
  {ssr: true, loading: () => <PageLoader />},
);
